// Tage und Zeitpunkte für die Seiten aus S5 und S7 (Akte, Leute und
// Geräte) – reine Logik, ohne React. Was es schon gibt, steht in anzeige.ts
// (wannZeigen, kalendertagZeigen …) und wird von dort genommen; hier nur,
// was dazukommt: ein Tag aus einem Datumsfeld, die Zeit im Verlauf, „gilt
// bis …“.

import { kalendertag } from "@happy-energy/kern";

/** Was ein Datumsfeld hergibt: ein Tag „JJJJ-MM-TT“, leer (null – der Tag wird gelöscht) oder Unsinn mit Meldung. */
export type TagEingabe = { ok: true; tag: string | null } | { ok: false; meldung: string };

/**
 * Liest ein Datumsfeld (`<input type="date">` liefert „JJJJ-MM-TT“ oder
 * leer). Leer heißt: kein Tag. Dieselbe Regel wie am Server (Kern,
 * `kalendertag`) – kein 30. Februar, kein Jahr 0002.
 */
export function tagLesen(text: string): TagEingabe {
  const t = text.trim();
  if (t === "") return { ok: true, tag: null };
  const gelesen = kalendertag.safeParse(t);
  if (!gelesen.success) return { ok: false, meldung: gelesen.error.issues[0]?.message ?? "Diesen Tag gibt es nicht." };
  const jahr = Number(t.slice(0, 4));
  if (jahr < 2000 || jahr > 2100) return { ok: false, meldung: "Bitte das Jahr prüfen." };
  return { ok: true, tag: t };
}

function uhrzeit(d: Date): string {
  return d.toLocaleTimeString("de-AT", { hour: "2-digit", minute: "2-digit" });
}

function tagNr(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/**
 * Wann etwas im Verlauf geschah – immer mit Uhrzeit: „heute 10:42“,
 * „gestern 16:05“, sonst „Mo, 12. Okt., 10:42“ (aus einem anderen Jahr mit
 * Jahr).
 */
export function verlaufZeit(iso: string, jetzt = new Date()): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const tage = Math.round((tagNr(jetzt) - tagNr(d)) / 86_400_000);
  if (tage === 0) return `heute ${uhrzeit(d)}`;
  if (tage === 1) return `gestern ${uhrzeit(d)}`;
  const tag = d.toLocaleDateString("de-AT", {
    weekday: "short",
    day: "numeric",
    month: "short",
    ...(d.getFullYear() !== jetzt.getFullYear() ? { year: "numeric" } : {}),
  });
  return `${tag}, ${uhrzeit(d)}`;
}

/** Bis wann etwas gilt (ein Einladungscode): „Do, 23. Okt., 14:00“. */
export function bisZeigen(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.toLocaleDateString("de-AT", { weekday: "short", day: "numeric", month: "short" })}, ${uhrzeit(d)}`;
}

/** Ist dieser Zeitpunkt später als jener? Fehlt einer, nein. */
export function spaeterAls(a: string | null | undefined, b: string | null | undefined): boolean {
  if (!a || !b) return false;
  const x = new Date(a).getTime();
  const y = new Date(b).getTime();
  return !Number.isNaN(x) && !Number.isNaN(y) && x > y;
}
